import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import DailyThroughputOverviewChart from "../components/DailyThroughputOverviewChart";
import DailyPlanningsTable from "../components/DailyPlanningsTable";
import DateSelector from "../components/DateSelector";
import DailyViewLayout from "../components/DailyViewLayout";
import { formatLocalDate } from "../utils/localDateTime";

const DailyComponentsOverview = () => {
  const { date } = useParams();
  const navigate = useNavigate();

  // Default to today if no date is provided
  const selectedDate = date || formatLocalDate(new Date());
  const [chartLoading, setChartLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(true);

  // Reset loading states when date changes
  useEffect(() => {
    setChartLoading(true);
    setTableLoading(true);
  }, [selectedDate]);

  // Navigate only if the URL doesn't match
  useEffect(() => {
    if (!date || date !== selectedDate) {
      navigate(`/chart/daily/plannings/${selectedDate}`, { replace: true });
    }
  }, [date, selectedDate, navigate]);

  const handleDateChange = useCallback((newDate) => {
    navigate(`/chart/daily/plannings/${newDate}`);
  }, [navigate]);

  // Check if any data is still loading
  const isAnyLoading = chartLoading || tableLoading;

  return (
    <DailyViewLayout date={selectedDate}>
      <DateSelector date={selectedDate} setDate={handleDateChange} disabled={isAnyLoading} />
      <DailyThroughputOverviewChart date={selectedDate} onLoadingChange={setChartLoading} />
      <DailyPlanningsTable
        date={selectedDate}
        onSelectWorkcell={(id) => navigate(`/chart/workcell/${id}/daily/${selectedDate}`)}
        onLoadingChange={setTableLoading}
      />
    </DailyViewLayout>
  );
};

export default DailyComponentsOverview;
